import { useDevTools } from 'studio5/contexts';
import FeatureBanner from './FeatureBanner';

const FeatureBannerProvider = () => {
  const { getAll } = useDevTools();

  return <FeatureBanner overrides={getAll()} />;
};

export default FeatureBannerProvider;
